import { SHyperLink } from 'style/CommonStyledComponent';
import { getTimeWithTimeZone } from 'utility/general';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { typeOfReview } from 'constants/globalEnum';
import { useHistory } from 'react-router';

const useArrangeMeeting = ({getMeetingArrangeList }) => {
    const arrangeMeeting = useSelector((state) => state.arrangeMeeting);
    const [sort, setSort] = useState('updateDtm');
    const [isDesc, setIsDesc] = useState(true);
    const history = useHistory();
    
    const columns = [
        {
            field: 'id',
            headerName: 'Meeting ID',
            width: 180,
            valueGetter: (params) => {
                return <SHyperLink onClick={() => history.push('/review/arrange-meeting?id=' + params.row.id)}>{params.row.id}</SHyperLink>;
            },
            onSort: (key, isDesc) => {
                setSort(key);
                setIsDesc(isDesc);
                getMeetingArrangeList(null, null, key, isDesc);
            },
        },
        {
            field: 'typeOfReview',
            headerName: 'Type of Review',
            width: 120,
            onSort: (key, isDesc) => {
                setSort(key);
                setIsDesc(isDesc);
                getMeetingArrangeList(null, null, key, isDesc);
            },
            valueGetter: (params) => {
                const item = typeOfReview.filter(item => item.key === params.row.typeOfReview)[0];
                return item?.display;
            },
        },
        {
            field: 'reviewMeetingDate',
            headerName: 'Meeting Date',
            width: 180,
            valueGetter: (params) => {
                return params.row.reviewMeetingDate ? getTimeWithTimeZone(params.row.reviewMeetingDate).format('YYYY-MM-DD') : '-';
            },
            onSort: (key, isDesc) => {
                setSort(key);
                setIsDesc(isDesc);
                getMeetingArrangeList(null, null, key, isDesc);
            },
        },
        {
            field: 'reviewDueDate',
            headerName: 'Due Date',
            width: 180,
            valueGetter: (params) => {
                return params.row.reviewDueDate ? getTimeWithTimeZone(params.row.reviewDueDate).format('YYYY-MM-DD') : '-';
            },
            onSort: (key, isDesc) => {
                setSort(key);
                setIsDesc(isDesc);
                getMeetingArrangeList(null, null, key, isDesc);
            },
        },
    ];

    return {
        rows: arrangeMeeting.meetingArrangeList,
        columns,
        sort,
        isDesc,
        total: arrangeMeeting.meetingArrangeTotal,
    };
};

export default useArrangeMeeting;
